export default __webpack_public_path__ + "static/media/404-error.df004178.png";